import { render, staticRenderFns } from "./PdvCloseCashierConference.vue?vue&type=template&id=0f2a8304&scoped=true"
import script from "./PdvCloseCashierConference.vue?vue&type=script&lang=js"
export * from "./PdvCloseCashierConference.vue?vue&type=script&lang=js"
import style0 from "./PdvCloseCashierConference.vue?vue&type=style&index=0&id=0f2a8304&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2a8304",
  null
  
)

export default component.exports